export default __webpack_public_path__ + "apply3508063.png";